import { render, staticRenderFns } from "./PriceTelemed.vue?vue&type=template&id=6596790c&"
import script from "./PriceTelemed.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PriceTelemed.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6596790c')) {
      api.createRecord('6596790c', component.options)
    } else {
      api.reload('6596790c', component.options)
    }
    module.hot.accept("./PriceTelemed.vue?vue&type=template&id=6596790c&", function () {
      api.rerender('6596790c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPriceBlockV2/components/PriceTelemed.vue"
export default component.exports